import React, { Component } from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import DisbursementModalUI from './DisbursementModalUI.js'

class DisbursementModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      disbursementDate: null,
      disbursementDateError: null,
      disbursementAmount: null,
      disbursementAmountError: null,
    }
  }

  render() {
    return (
      <DisbursementModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        // form fields
        disbursementDate={this.state.disbursementDate}
        onDisbursementDateChange={(selectedDateISO) => {
          this.setState({disbursementDate: selectedDateISO})
        }}
        disbursementDateError={this.state.disbursementDateError}
        setDisbursementDateError={(error) => { this.setState({ disbursementDateError: error }) }}
        disbursementAmount={this.state.disbursementAmount}
        onDisbursementAmountChange={(event) => { this.setState({ disbursementAmount: event.target.value})}}
        disbursementAmountError={this.state.disbursementAmountError}
        setDisbursementAmountError={(error) => { this.setState({ disbursementAmountError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/disbursements`,
      this.onSubmitCallback, {
        disbursementDate: this.state.disbursementDate,
        disbursementAmount: this.state.disbursementAmount,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  onCancelClick = () => {
    this.setState({
      errorList: null,
      submitted: false,
    })
    this.props.onCancelClick()
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
  }
}

export default DisbursementModalSF
